import { Box, Skeleton, Text } from '@chakra-ui/react'
import {
    ApplicationState,
    ApplicationStateToCandidateDescription,
    ApplicationStateToColorScheme,
} from 'entities/application'

export const ApplicationStatus = ({
    status = ApplicationState.Pending,
    isLoaded,
}: {
    status: ApplicationState
    isLoaded: boolean
}) => {
    const bgColor = `${ApplicationStateToColorScheme[status]}.300`

    return (
        <Skeleton
            h={isLoaded ? 'auto' : '30px'}
            isLoaded={isLoaded}
            pos="absolute"
            w="full"
            top="0"
            left="0"
        >
            <Box bgColor={bgColor} textAlign="center" py="3px" borderTopRadius="16px">
                <Text
                    w="full"
                    variant="bodyTextSmall"
                    color="white"
                    fontWeight="semibold"
                >
                    {ApplicationStateToCandidateDescription[status]}
                </Text>
            </Box>
        </Skeleton>
    )
}
